import React, { Component } from 'react';
import { css } from 'aphrodite';

import { Flexbox, Font, Layout, Text } from './Styles';

import Game from './Game';
import Scenario from './models/Scenario';
import Progress from './models/Progress';

import Locale from './models/Locale';
import Impact from './models/Impact';

class ScenarioPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scenario: null,
      errors: []
    };
  }

  render() {
    if (this.state.scenario) {
      let score = this.props.initialScore || this.state.scenario.startingScore.bestComponents(new Impact(Progress.bestMoney(), 0, 0));
      return(
        <div className={css(Layout.scrollingContentArea)}>
          <div className={css(Layout.contentArea)}>
            <Game scenario={this.state.scenario} initialScore={score}/>
          </div>
        </div>
      );
    } else {
      let scenarioName = this.props.match? this.props.match.params.scenarioName : "unknown";
      return(
        <div className={css(Layout.fullScrollingContentArea)}>
          <div className={css(Layout.contentArea)}>
            <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter)}>
              <div className={css(Font.hero, Text.heading)}>{Locale.localized("Loading") + " " + scenarioName}</div>
              {this.state.errors.length > 0 &&
                <div>
                  <h2>Errors</h2>
                  <ul>
                    {this.state.errors.map(error => {
                      return <li key={error.row}>{error.message}</li>
                    })}
                  </ul>
                </div>
              }
            </div>
          </div>
        </div>
      );
    }
  }

  componentDidMount() {
    if (this.props.scenario) {
      this.setState({scenario: this.props.scenario});
    } else {
      let result = Scenario.loadScenario(this.props.match.params.scenarioName);
      this.setState({scenario: result.scenario, errors: result.errors});
    }
  }
}

export default ScenarioPlayer;



// WEBPACK FOOTER //
// ./src/ScenarioPlayer.js